import { Accordion } from '@diamond-design/components';
import PropTypes from 'prop-types';
import styles from './accordionWrapper.module.scss';

function AccordionWrapper({
  id,
  head,
  body,
  containerStyle = '',
  headStyle = '',
  bodyStyle = '',
  borderTopHidden = false,
  borderBottom = false,
  ...rest
}) {
  return (
    <div className={styles.accordion}>
      <Accordion
        id={id}
        headerContent={head}
        /* eslint-disable-next-line react/no-children-prop */
        children={body}
        headerContentStyle={`${styles.accordionItemHeader} ${headStyle}`}
        containerStyle={` ${styles.accordionContainer} ${containerStyle} ${
          borderBottom && styles.borderBottom
        } ${borderTopHidden && styles.borderTopHidden}`}
        contentStyle={`${styles.accordionContent} ${bodyStyle}`}
        {...rest}
      />
    </div>
  );
}
AccordionWrapper.propTypes = {
  id: PropTypes.string.isRequired,
  head: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  headStyle: PropTypes.string,
  containerStyle: PropTypes.string,
  bodyStyle: PropTypes.string,
  rest: PropTypes.object,
};

export default AccordionWrapper;
